import type { HierarchyRectangularNode } from 'd3-hierarchy';

import type { InternalTreeMapNode } from '../types/internal.js';

export const getNodePosition = (
  entry: HierarchyRectangularNode<InternalTreeMapNode>,
): { x: number; y: number } => ({ x: entry.x0, y: entry.y0 });
